// module
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

// my js file
import NavButton from './NavButton';
import NavManualLink from './NavManualLink';
import NavManualLinkSub from './NavManualLinkSub';

export default withRouter(function Nav({ location }) {
    const [currentPath, setCurrentPath] = useState(location.pathname);
    const [height, setHeight] = useState(0);
  
    useEffect(() => {
        const { pathname } = location;
        const body = document.getElementById('root');
        const window_size = window.getComputedStyle(body).height;

        setCurrentPath(pathname);
        setHeight(window_size);
        console.log(currentPath, height);
    }, [location, currentPath, height]);

    return(
        <div className="nav" style={{"height":height}}>
            <label hidden={true}>{currentPath}</label>
            <NavButton buttonName="Home" to="/" />
            <NavButton buttonName="GAAP Manual" to="/manual" />
            <div className="tree_manual">
                <NavManualLink linkName="Sequencing" to="/Gaap01"/><br/>
                <NavManualLink linkName="Error Correction" to="/Gaap02" />
                <NavManualLink linkName="Denovo Assembly" to="/Gaap03" subMenu={"Denovo"} />
                <div id="Denovo_div" className="sub_manual" style={{display:"none"}}>
                    <NavManualLinkSub linkName="Genome Assembly" to="/Gaap03" 
                        subList={[
                            {name:"SOAPdenovo", link:"/Gaap03"},
                            {name:"ALLPATHS-LG", link:"/Gaap03_AllPath"},
                            {name:"Abyss", link:"/Gaap03_Abyss"},
                            {name:"Velvet", link:"/Gaap03_Velvet"},
                            {name:"GapCloser",link:"/Gaap03_Gap"}
                        ]}
                    />
                    <NavManualLinkSub linkName="Transcriptome Assembly" to="/Gaap04"
                        subList={[
                            {name:"Trinity", link:"Gaap04"}
                        ]}
                    />
                </div>
                <NavManualLink linkName="Annotation" to="/Gaap05" subMenu={"Annotation"} />
                <div id="Annotation_div" className="sub_manual" style={{display:"none"}}>
                    <NavManualLinkSub linkName="Structure Annotation" to="/Gaap05" 
                        subList={[
                            {name:"Repeat identification", link:"/Gaap05"}, 
                            {name:"Ab initio prediction", link:"/Gaap06"},
                            {name:"Evidence-driven prediction", link:"/Gaap07"},
                            {name:"Consensus gene prediction", link:"/Gaap08"},
                            {name:"Identification of UTR", link:"/Gaap09"},
                        ]}
                    />
                    <NavManualLinkSub linkName="Functional Annotation" to="/Gaap10"
                        subList={[
                            {name:"Homology search", link:"/Gaap10"},
                            {name:"GO term mapping", link:"/Gaap11"},
                        ]}
                    />
                </div>
            </div>
            <button className="nav_button">
                <a href="mailto:jiwon@hallym.ac.kr" style={{textDecoration:"none",color:"black"}}>
                    Contact
                </a>
            </button>
        </div>
    );
});